/**
 * assets/wall-simulator-config.js
 * Configurações editáveis do simulador.
 * Altere este arquivo sem precisar tocar na lógica principal.
 */

const WALL_SIMULATOR_CONFIG = Object.freeze({

  // Coleções usadas para carregar o catálogo de obras
  collectionHandles: ['artprint', 'signature'],

  // Limite máximo por página da API Shopify (máx. 250)
  productFetchLimit: 250,

  // Quantos resultados exibir visualmente na busca por vez
  visibleSearchLimit: 80,

  // Tamanhos disponíveis — devem corresponder às options do produto
  sizes: ['A4', 'A3', 'A2', 'A1'],

  // Papéis disponíveis
  papers: [
    { id: 'fine-art', label: 'Fine Art' },
    { id: 'canvas',   label: 'Canvas'   },
  ],

  // Molduras disponíveis
  // color: usado para renderizar o swatch e a borda do quadro na cena
  frames: [
    { id: 'none',    label: 'Sem moldura', color: 'transparent' },
    { id: 'black',   label: 'Preta',       color: '#111111'     },
    { id: 'white',   label: 'Branca',      color: '#f0ece0'     },
    { id: 'natural', label: 'Natural',     color: '#b88b5a'     },
    { id: 'freijo',  label: 'Freijó',      color: '#c9a56f'     },
    { id: 'imbuia',  label: 'Imbuia',      color: '#5b3824'     },
  ],

  // Ambientes (cor de fundo da parede)
  rooms: [
    { id: 'light',  label: 'Sala clara',       color: '#ded8cc' },
    { id: 'warm',   label: 'Ambiente quente',  color: '#c6ad91' },
    { id: 'gray',   label: 'Parede cinza',     color: '#b9b9b4' },
    { id: 'green',  label: 'Verde suave',      color: '#aeb8a6' },
  ],

  // Escala de referência (px de largura na cena) por tamanho.
  // Ajuste conforme a proporção visual desejada.
  baseWidthBySize: {
    A4: 130,
    A3: 180,
    A2: 250,
    A1: 340,
  },

  // Proporção altura/largura padrão (papel retrato).
  // Usada quando a imagem não estiver disponível.
  defaultAspectRatio: 1.414, // √2 — proporção ISO A

  // Espessura da borda da moldura em px
  frameThickness: {
    none:    0,
    black:   10,
    white:   10,
    natural: 12,
    freijo:  12,
    imbuia:  14,
  },

  // Mensagens de interface
  messages: {
    loading:          'Carregando catálogo…',
    loadError:        'Não foi possível carregar o catálogo. Recarregue a página.',
    noResults:        'Nenhuma obra encontrada.',
    variantNotFound:  'Combinação indisponível para esta obra.',
    cartSuccess:      'Itens adicionados ao carrinho!',
    cartError:        'Erro ao adicionar ao carrinho. Tente novamente.',
    emptyComposition: 'Adicione ao menos uma obra antes de comprar.',
  },

});